import { createContext } from 'react';

import type { FilterFieldContextProps } from './FilterFieldContext.types.js';
import { DEFAULT_SUGGESTIONS_COUNT } from '../suggestions/suggestions-config.js';

/** @internal */
export const FilterFieldContext = createContext<FilterFieldContextProps>({
  applySuggestion: () => null,
  dispatch: () => null,
  autoSuggestions: {},
  defaultSuggestionsCount: DEFAULT_SUGGESTIONS_COUNT,
  recentSuggestionValues: [],
  pinnedSuggestionValues: [],
  logicalOperatorSuggestionValues: [],
  pastedContentSuggestionValues: [],
  searchSuggestionValues: [],
  fallbackKeySuggestionValues: [],
  statementSuggestionValues: [],
  suggestionsOverlayRef: null,
  triggerRef: null,
  filterNamespace: null,
  editorView: null,
  handleNextSuggestion: () => null,
});
